import Vue from 'vue';
import Vuex, { Store } from 'vuex';

Vue.use(Vuex);
Vue.config.devtools = true

export default new Vuex.Store({
	state: {
		token: localStorage.getItem('token') || undefined,
		contactId: localStorage.getItem('contactId') || undefined, //kinda user token
		clientId: localStorage.getItem('clientId') || undefined, //kinda user token
		franchiseID: '',
		login: '',
		email: '',
		phone: '',
		lastName: '',
		firstName: '',
		countWorkOrders: '',

		displayHours: 0,
		displayMinutes: 0,
		displaySeconds: 0,
		displayDays: 0,
		seconds: 1000,
		minutes: 0,
		hours: 0,
		days: 0,

		address: '',
		city: '',
		country: '',
		postcode: "",
		stateCountry: '',

		primaryFranchise: '',
		serviceID: '',
		priceListID: '',

		deliveryTime: '',
		deliveryDate: '',
		deliveryRouteID: '',
		deliveryLockID: '',
		pickUpLockID: '',


		pickUpDate: '',
		pickUpTime: '',
		pickUpRouteID: '',

		jobID: '',

		overlay: false,

		isFirstStepComplited: false,
		isSecondStepComplited: false,
		isThirdStepComplited: false,
		isFourthStepComplited: false,
		isTimerInvalid: false,
		timerId: null,
	},
	getters: {
		timerId: state => state.timerId,
		token: state => state.token,

		displayHours: state => state.displayHours,
		displayMinutes: state => state.displayMinutes,
		displaySeconds: state => state.displaySeconds,
		displayDays: state => state.displayDays,
		seconds: state => state.seconds,
		minutes: (state, getters) => getters.seconds * 60,
		hours: (state, getters) => getters.minutes * 60,
		days: (state, getters) => getters.hours * 24,
		fullTime: (state) => [state.displayDays, state.displayHours, state.displayMinutes, state.displaySeconds],

		address: state => state.address,
		contactId: state => state.contactId,
		clientId: state => state.clientId,
		franchiseID: state => state.franchiseID,
		login: state => state.login,

		email: state => state.email,
		phone: state => state.phone,
		lastName: state => state.lastName,
		firstName: state => state.firstName,
		countWorkOrders: state => state.countWorkOrders,

		priceListID: state => state.priceListID,
		serviceID: state => state.serviceID,
		deliveryDate: state => state.deliveryDate,
		deliveryRouteID: state => state.deliveryRouteID,
		deliveryTime: state => state.deliveryTime,
		pickUpDate: state => state.pickUpDate,
		pickUpTime: state => state.pickUpTime,
		pickUpRouteID: state => state.pickUpRouteID,
		deliveryLockID: state => state.deliveryLockID,
		pickUpLockID: state => state.pickUpLockID,

		jobID: state => state.jobID,

		postcode: state => state.postcode,
		city: state => state.city,
		country: state => state.country,
		stateCountry: state => state.stateCountry,
		primaryFranchise: state => state.primaryFranchise,

		overlay: state => state.overlay,
		isTimerInvalid: state => state.isTimerInvalid,

		isFirstStepComplited: state => state.isFirstStepComplited,
		isSecondStepComplited: state => state.isFirstStepComplited,
		isThirdStepComplited: state => state.isThirdStepComplited,
		isFourthStepComplited: state => state.isFourthStepComplited,
	},
	mutations: {
		setTimerId(state, id) {
			state.timerId = id;
		},
		setFirstStepComplited(state) {
			sessionStorage.setItem('isFirstStepComplited', 'true');
			localStorage.setItem('isFirstStepComplited', 'true');
			state.isFirstStepComplited = true;
		},
		setThirdStepComplited(state) {
			localStorage.setItem('isThirdStepComplited', 'true');
			state.isThirdStepComplited = true;
		},
		setSecondStepComplited(state) {
			localStorage.setItem('isSecondStepComplited', 'true');
			state.isSecondStepComplited = true;
		},
		setFourthStepComplited(state) {
			localStorage.setItem('isFourthStepComplited', 'true');
			state.isFourthStepComplited = true;
		},
		setjobID(state, jobID) {
			localStorage.setItem('jobID', jobID);
			state.jobID = jobID;
		},
		updateContactId(state, { contactId, clientId }) {
			localStorage.setItem('contactId', contactId);
			localStorage.setItem('clientId', clientId);
			state.contactId = contactId;
			state.clientId = clientId;
		},
		updateClientId(state, clientId) {
			localStorage.removeItem('clientId');
			localStorage.setItem('clientId', clientId);
			state.clientId = clientId;
		},
		clearStore(state) {
			state.address = '';
			localStorage.removeItem('address');
			state.postcode = '';
			localStorage.removeItem('postcode');
			state.city = '';
			localStorage.removeItem('city');
			state.country = '';
			localStorage.removeItem('country');
			state.stateCountry = '';
			localStorage.removeItem('stateCountry');

			state.franchiseID = '';
			localStorage.removeItem('franchiseID');

			state.pickUpDate = '';
			localStorage.removeItem('pickUpDate');
			state.pickUpLockID = '';
			localStorage.removeItem('pickUpLockID');
			state.pickUpRouteID = '';
			localStorage.removeItem('pickUpRouteID');
			state.pickUpTime = '';
			localStorage.removeItem('pickUpTime');

			state.jobID = '';
			localStorage.removeItem('jobID');

			state.deliveryDate = '';
			localStorage.removeItem('deliveryDate');
			state.deliveryLockID = '';
			localStorage.removeItem('deliveryLockID');
			state.deliveryRouteID = '';
			localStorage.removeItem('deliveryRouteID');
			state.deliveryTime = '';
			localStorage.removeItem('deliveryTime');

			state.serviceID = '';
			localStorage.removeItem('serviceID');

			state.isFirstStepComplited = false;
			localStorage.removeItem('isFirstStepComplited');

			state.isSecondStepComplited = false;
			localStorage.removeItem('isSecondStepComplited');

			state.isThirdStepComplited = false;
			localStorage.removeItem('isThirdStepComplited');

			state.isFourthStepComplited = false;
			localStorage.removeItem('isFourthStepComplited');

		},
		clearStoreEdit(state) {
			state.pickUpDate = '';
			localStorage.removeItem('pickUpDate');
			state.pickUpLockID = '';
			localStorage.removeItem('pickUpLockID');
			state.pickUpRouteID = '';
			localStorage.removeItem('pickUpRouteID');
			state.pickUpTime = '';
			localStorage.removeItem('pickUpTime');

			state.jobID = '';
			localStorage.removeItem('jobID');

			state.deliveryDate = '';
			localStorage.removeItem('deliveryDate');
			state.deliveryLockID = '';
			localStorage.removeItem('deliveryLockID');
			state.deliveryRouteID = '';
			localStorage.removeItem('deliveryRouteID');
			state.deliveryTime = '';
			localStorage.removeItem('deliveryTime');

			state.serviceID = '';
			localStorage.removeItem('serviceID');

			state.isSecondStepComplited = false;
			localStorage.removeItem('isSecondStepComplited');

			state.isThirdStepComplited = false;
			localStorage.removeItem('isThirdStepComplited');

			state.isFourthStepComplited = false;
			localStorage.removeItem('isFourthStepComplited');

		},
		setDeliveryDate(state, date) {
			localStorage.setItem('deliveryDate', date);
			state.deliveryDate = date;
		},
		setPickUpDate(state, date) {
			localStorage.setItem('pickUpDate', date);
			state.pickUpDate = date;
		},
		setOverlay(state, overlay) {
			state.overlay = overlay;
		},
		setDeliveryLockID(state, deliveryLockID) {
			localStorage.setItem('deliveryLockID', deliveryLockID);
			state.deliveryLockID = deliveryLockID;
		},
		setPickUpLockID(state, pickUpLockID) {
			localStorage.setItem('pickUpLockID', pickUpLockID);
			state.pickUpLockID = pickUpLockID;
		},
		setPickUpRouteID(state, pickUpRouteID) {
			localStorage.setItem('pickUpRouteID', pickUpRouteID);
			state.pickUpRouteID = pickUpRouteID;
		},
		setDeliveryRouteID(state, deliveryRouteID) {
			localStorage.setItem('deliveryRouteID', deliveryRouteID);
			state.deliveryRouteID = deliveryRouteID;
		},
		setPickUpTime(state, pickUpTime) {
			localStorage.setItem('pickUpTime', pickUpTime);
			state.pickUpTime = pickUpTime;
		},
		setDeliveryTime(state, deliveryTime) {
			localStorage.setItem('deliveryTime', deliveryTime);
			state.deliveryTime = deliveryTime;
		},
		editContactId(state, contactId) {
			localStorage.removeItem('contactId');
			localStorage.setItem('contactId', contactId);
			state.contactId = contactId;
		},
		updateToken(state, newToken) {
			localStorage.setItem('token', newToken);
			state.token = newToken;
		},
		updateEmail(state, email) {
			state.email = email;
		},
		updateServiceID(state, serviceID) {
			localStorage.setItem('serviceID', serviceID);
			state.serviceID = serviceID;
		},
		updateCountWorkOrders(state, countWorkOrders) {
			state.countWorkOrders = countWorkOrders;
		},
		updateLastName(state, lastName) {
			state.lastName = lastName;
		},
		updatePhone(state, phone) {
			state.phone = phone;
		},
		updateFirstName(state, firstName) {
			state.firstName = firstName;
		},
		updatePriceListID(state, priceListID) {
			state.priceListID = priceListID;
		},
		logout(state) {
			localStorage.removeItem('contactId');
			localStorage.removeItem('clientId');
			localStorage.removeItem('token');
			state.contactId = undefined;
			state.clientId = undefined;
		},
		updateDays(state, days) {
			state.displayDays = days < 10 ? '0' + days : days
			// @ts-ignore
			localStorage.setItem('displayDays', state.displayDays)
		},
		updateHours(state, hours) {
			state.displayHours = hours < 10 ? '0' + hours : hours
			// @ts-ignore
			localStorage.setItem('displayHours', state.displayHours)
		},
		updateMinutes(state, minutes) {
			state.displayMinutes = minutes < 10 ? '0' + minutes : minutes
			// @ts-ignore
			localStorage.setItem('displayMinutes', state.displayMinutes)
		},
		updateSeconds(state, seconds) {
			state.displaySeconds = seconds < 10 ? '0' + seconds : seconds
			// @ts-ignore
			localStorage.setItem('displaySeconds', state.displaySeconds)
		},
		updateAddress(state, address) {
			sessionStorage.setItem('address', address);
			localStorage.setItem('address', address);
			state.address = address
		},
		updatePostcode(state, postcode) {
			sessionStorage.setItem('postcode', postcode);
			localStorage.setItem('postcode', postcode);
			state.postcode = postcode
		},
		updateCity(state, city) {
			sessionStorage.setItem('city', city);
			localStorage.setItem('city', city);
			state.city = city
		},
		updateStateCountry(state, stateCountry) {
			sessionStorage.setItem('stateCountry', stateCountry);
			localStorage.setItem('stateCountry', stateCountry);
			state.stateCountry = stateCountry
		},
		updateCountry(state, country) {
			sessionStorage.setItem('country', country);
			localStorage.setItem('country', country);
			state.country = country
		},
		updateLogin(state, login) {
			state.login = login
		},
		updateFranchiseID(state, franchiseID) {
			sessionStorage.setItem('franchiseID', franchiseID);
			localStorage.setItem('franchiseID', franchiseID);
			state.franchiseID = franchiseID
		},
		isTimerInvalid(state, isInvalid) {
			state.isTimerInvalid = isInvalid
		},
		stopTimer(state) {
			// @ts-ignore
			clearInterval(state.timerId)
			state.timerId = null;
		},
		setTimerFromStorage(state) {
			// @ts-ignore
			state.displaySeconds = localStorage.getItem('displaySeconds')
			// @ts-ignore
			state.displayMinutes = localStorage.getItem('displayMinutes')
			// @ts-ignore
			state.displayHours = localStorage.getItem('displayHours')
			// @ts-ignore
			state.displayDays = localStorage.getItem('displayDays')

			localStorage.removeItem('displaySeconds')
			localStorage.removeItem('displayMinutes')
			localStorage.removeItem('displayHours')
			localStorage.removeItem('displayDays')
		}


	},
	actions: {
		showRemaning({ commit, getters }) {
			if (getters.timerId) {
				clearInterval(getters.timerId)
			}
			const date = new Date()

			let end = new Date(date.setMinutes(date.getMinutes() + 10))

			const timer = setInterval(() => {
				const now = new Date()
				let distanse = end.getTime() - now.getTime()


				if (distanse < 0) {
					commit('updateSeconds', 0)
					commit('updateMinutes', 0)
					commit('updateHours', 0)
					commit('updateDays', 0)
					clearInterval(timer)
					return
				}

				let days = Math.floor(distanse / getters.days)
				let hours = Math.floor((distanse % getters.days) / getters.hours)
				let minutes = Math.floor((distanse % getters.hours) / getters.minutes)
				let seconds = Math.floor((distanse % getters.minutes) / getters.seconds)
				if (days < 0) days = 0;
				if (hours < 0) hours = 0;
				if (minutes < 0) minutes = 0;
				if (seconds < 0) seconds = 0;

				commit('updateSeconds', seconds)
				commit('updateMinutes', minutes)
				commit('updateHours', hours)
				commit('updateDays', days)

				if (getters.fullTime.every((i: Number) => i === 0) || getters.isTimerInvalid) {
					commit('isTimerInvalid', false)
					clearInterval(timer);
				}
			}, 1000)
			commit('setTimerId', timer);
		},
		continueTimer({ commit, getters }) {
			if (getters.timerId) return;
			const date = new Date();

			if (localStorage.getItem('displaySeconds') !== undefined && !getters.displaySeconds) {
				commit('setTimerFromStorage')
			}

			let end = (+getters.displaySeconds + +getters.displayMinutes * 60) * 1000 + date.getTime();

			const timer = setInterval(() => {
				const now = new Date()
				let distanse = end - now.getTime()

				if (distanse < 0) {
					commit('updateSeconds', 0)
					commit('updateMinutes', 0)
					commit('updateHours', 0)
					commit('updateDays', 0)
					clearInterval(timer)
					return
				}

				let days = Math.floor(distanse / getters.days)
				let hours = Math.floor((distanse % getters.days) / getters.hours)
				let minutes = Math.floor((distanse % getters.hours) / getters.minutes)
				let seconds = Math.floor((distanse % getters.minutes) / getters.seconds)
				if (days < 0) days = 0;
				if (hours < 0) hours = 0;
				if (minutes < 0) minutes = 0;
				if (seconds < 0) seconds = 0;

				commit('updateSeconds', seconds)
				commit('updateMinutes', minutes)
				commit('updateHours', hours)
				commit('updateDays', days)

				if (getters.fullTime.every((i: Number) => i === 0) || getters.isTimerInvalid) {
					commit('isTimerInvalid', false)
					clearInterval(timer);
				}
			}, 1000)
			commit('setTimerId', timer);
		},

	},
	modules: {
	},
});
